module.exports = __webpack_public_path__ + "img/24.1463e640.png";